import { render, staticRenderFns } from "./PublicacionesNueva.vue?vue&type=template&id=2afed9c7&"
import script from "./PublicacionesNueva.vue?vue&type=script&lang=js&"
export * from "./PublicacionesNueva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports